/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Input} from '@angular/core';


let /** @type {?} */ nextUniqueId = 0;
/**
 * Hint text to be shown underneath the form field control.
 */
export class MdHint {
/**
 * Whether to align the hint label at the start or end of the line.
 */
align: 'start' | 'end' = 'start';
/**
 * Unique ID for the hint. Used for the aria-describedby on the form field control.
 */
id: string = `mat-hint-${nextUniqueId++}`;
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-hint, mat-hint',
  host: {
    'class': 'mat-hint',
    '[class.mat-right]': 'align == "end"',
    '[attr.id]': 'id',
    // Remove align attribute to prevent it from interfering with layout.
    '[attr.align]': 'null',
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'align': [{ type: Input },],
'id': [{ type: Input },],
};
}

function MdHint_tsickle_Closure_declarations() {
/** @type {?} */
MdHint.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdHint.ctorParameters;
/** @type {?} */
MdHint.propDecorators;
/**
 * Whether to align the hint label at the start or end of the line.
 * @type {?}
 */
MdHint.prototype.align;
/**
 * Unique ID for the hint. Used for the aria-describedby on the form field control.
 * @type {?}
 */
MdHint.prototype.id;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
